module.exports = __webpack_public_path__ + "assets/img/title-0a46fad9.png";